export const extractGooglePlaceData = googlePlace => {
  const address: any = {
    street_number: {},
    route: {},
    locality: {},
    administrative_area_level_1: {},
    postal_code: {},
  };

  googlePlace.address_components.forEach(
    (addressComponent: { long_name: string; short_name: string; types: string[] }) => {
      address[addressComponent.types[0]] = {
        long: addressComponent.long_name,
        short: addressComponent.short_name,
      };
    }
  );

  return {
    address1: [address.street_number.long, address.route.short].join(" "),
    address2: address.subpremise ? "#" + address.subpremise.long : "",
    city: address.locality.long,
    name: googlePlace.name,
    state: address.administrative_area_level_1.short,
    zip: address.postal_code.long,
  };
};
